import { useContext } from 'react';
import { WarboxMessageContext } from 'src/contexts/warboxMessage';

export const useWarboxMessage = () => useContext(WarboxMessageContext);
